import { render, staticRenderFns } from "./UserAccountDetailsCompanyInformationTaxIdVerification.vue?vue&type=template&id=1011ed44&"
import script from "./UserAccountDetailsCompanyInformationTaxIdVerification.vue?vue&type=script&lang=js&"
export * from "./UserAccountDetailsCompanyInformationTaxIdVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports